import React, { useState } from 'react';
import { OnChangeCallback } from '../../../../../../util/UtilityTypes'
import { Card, CardHeader, CardBody, Collapse, Button, FormGroup, Form, Table, Input } from 'reactstrap';
import { useTranslation } from 'react-i18next';

interface FormField<TValue> {
    value: TValue
}

interface FormData {
    newReportReceiver: FormField<string>
}

interface UserSyncReportRecipientsProps {
    reportRecipients: string[]
    onChange: OnChangeCallback<string[]>
    disableInput?: boolean
}

const UserSyncReportRecipients: React.FC<UserSyncReportRecipientsProps> = (props) => {
    const [open, setOpen] = useState(true);
    const { t } = useTranslation(['configuration', 'common'])

    const remove = (index: number) => {
        const clone = [...props.reportRecipients];
        clone.splice(index, 1);
        props.onChange('reportRecipients', clone);
    }

    const add = (e: React.SyntheticEvent) => {
        e.preventDefault();
        const target = e.target as typeof e.target & FormData;
        const emailAddress = target.newReportReceiver.value;
        target.newReportReceiver.value = '';

        if (!props.reportRecipients.some(x => x === emailAddress)) {
            props.onChange('reportRecipients', [...props.reportRecipients, emailAddress]);
        }
    }

    return (
        <Card>
            <CardHeader tag="h4">
                <Button outline color="secondary" style={{ width: '37px', float: 'right' }} onClick={() => setOpen(!open)}>{open ? '-' : '+'}</Button>
                {t('userSyncReportRecipients.title', {ns: 'configuration'})}
            </CardHeader>
            <Collapse isOpen={open}>
                <CardBody className="multiple-cards">
                    <FormGroup>
                        <Form onSubmit={add}>
                            <Table striped>
                                <thead>
                                    <tr>
                                        <th>{t('userSyncReportRecipients.emailAddress', {ns: 'configuration'})}</th>
                                        <th />
                                    </tr>
                                </thead>
                                <tbody>
                                    {props.reportRecipients.map((rr, index) => (
                                        <tr key={index}>
                                            <td>{rr}</td>
                                            <td className='text-right'>
                                                <Button color="danger" onClick={() => remove(index)} disabled={props.disableInput}>{t('action.remove', {ns: 'common'})}</Button>
                                            </td>
                                        </tr>
                                    ))}
                                    <tr>
                                        <td>
                                            <Input type="email" name="newReportReceiver" disabled={props.disableInput} required placeholder={t('userSyncReportRecipients.emailAddress', {ns: 'configuration'})} />
                                        </td>
                                        <td className='text-right'>
                                            <Button color="primary" type="submit" disabled={props.disableInput}>{t('action.add', {ns: 'common'})}</Button>
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        </Form>
                    </FormGroup>
                </CardBody>
            </Collapse>
        </Card>);
}

export default UserSyncReportRecipients;